import { LEGAL_ENTITY } from '../constants/LegalEntity';

export function interpolateLegalText(text) {
  if (!text) {
    return '';
  }

  return text.replace(/\{\{(\w+)\}\}/g, (_, key) => LEGAL_ENTITY[key] ?? '');
}
